import React from "react";

export default function Features() {
  return (
    <div className="main-page">
      <h2>
        What can Rabbi Rabbit do for you? <br></br> Discover the features that
        will transform your learning experience.
      </h2>
      <h3>Interactive Vocabulary Practice</h3>
      <p>
        Rabbi Rabbit's interactive typing exercises means no more boring
        flashcards or repetitive drills. Our platform simulates real
        conversations, allowing you to type in responses and encounter words in
        meaningful contexts.
      </p>
      <h3>Spaced Repetition for Optimal Retention</h3>
      <p>
        Rabbi Rabbit's spaced repetition algorithm ensures you encounter
        vocabulary at precisely timed intervals for optimal retention. You'll
        learn to recognize words in their natural habitat, enabling you to use
        them in your own conversations with ease.
      </p>
      <h3>Personalized Learning Experience</h3>
      <p>
        Rabbi Rabbit adapts to your progress, tailoring your learning journey.
        Whether you're a dedicated language student or squeezing in study time
        amidst a busy schedule, our platform empowers you to learn at your own
        pace. If you're struggling with a word, Rabbi Rabbit will provide more
        practice to help you master it. If you're acing a word, Rabbi Rabbit
        will move on to new words to keep you challenged.
      </p>
      <h3>Comprehensive Word Library</h3>
      <p>
        Rabbi Rabbit's word library is continuously expanding, with new words
        added regularly. From fundamental Hebrew words for beginners to
        sophisticated expressions for advanced learners, we strive to provide a
        comprehensive and ever-evolving resource for all language enthusiasts.
      </p>
      <h3>Easy to read progress bar</h3>
      <p>
        Rabbi Rabbit's progress bar is a visual representation of your progress
        in mastering the set of lessons that you most recently unlocked. It is
        based on the number of words from that lesson that you have ranked up to
        mastery level 3 or higher.
      </p>
      <h3>Unlock new lessons as you progress</h3>
      <p>
        Rabbi Rabbit's lessons are unlocked when you have mastered 80% of the
        words in your current set of lessons. A word is considered mastered when
        you have ranked it up to mastery level 3 or higher.
      </p>
      <h3>Track your progress</h3>
      <p>
        Rabbi Rabbit's progress page shows the current mastery rank for words
        that you've learned. Just select the lesson set you want to review from
        the dropdown menu. The lesson options will expand as you unlock more
        lessons and the page will populate with more vocab words as you go
        through the lessons and words are added to your review que.
      </p>
      <h3>Track your reviews</h3>
      <p>
        Rabbi Rabbit's reviews page shows the current words in your review que.
        Just select the lesson set you want to review from the dropdown menu.
        The lesson options will expand as you unlock more lessons and the page
        will populate with more vocab words as you go through the lessons and
        words are added to your review que.
      </p>
      <h3>Cusomizable language settings</h3>
      <p>
        Rabbi Rabbit's language settings allow you to customize your experience
        by choosing between Hebrew, Hebrew with nikkud, or english letter
        transliteration for your reviews allowing you to practice reading at
        your comfort level.
      </p>
    </div>
  );
}
